import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import App from './App';
import Playground from './playground';
import reportWebVitals from './reportWebVitals';

ReactGA.initialize([
  {
    trackingId: 'G-CCY6VMBKRV',
    gaOptions: { send_page_view: false },
  },
]);

function AnalyticsTracker() {
  const location = useLocation();
  const lastTrackedKey = useRef(null);
  const pagePath = `${location.pathname}${location.search}`;

  useEffect(() => {
    if (lastTrackedKey.current !== location.key) {
      ReactGA.send({ hitType: 'pageview', page: pagePath });
      lastTrackedKey.current = location.key;
    }

    let accumulatedMs = 0;
    let activeSince = document.visibilityState === 'visible' ? Date.now() : null;

    const flushActiveTime = () => {
      if (activeSince !== null) {
        accumulatedMs += Date.now() - activeSince;
        activeSince = document.visibilityState === 'visible' ? Date.now() : null;
      }

      const reportableMs = Math.floor(accumulatedMs / 1000) * 1000;
      if (reportableMs > 0) {
        ReactGA.event('page_engagement', {
          page_path: pagePath,
          engagement_time_msec: reportableMs,
        });
        accumulatedMs -= reportableMs;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        flushActiveTime();
      } else if (activeSince === null) {
        activeSince = Date.now();
      }
    };

    const engagementInterval = window.setInterval(flushActiveTime, 10000);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pagehide', flushActiveTime);

    return () => {
      window.clearInterval(engagementInterval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pagehide', flushActiveTime);
      flushActiveTime();
    };
  }, [location.key, pagePath]);

  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/playground" element={<Playground />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
